export const GET = {
  REQUEST: 'ServiceRequests/GetDiscussion/Request',
  SUCCESS: 'ServiceRequests/GetDiscussion/Success',
  FAILURE: 'ServiceRequests/GetDiscussion/Failure',
  RESET: 'ServiceRequests/GetDiscussion/Clear'
};

export const MARK_UNREAD = {
  REQUEST: 'ServiceRequests/MarkDiscussionUnread/Request',
  SUCCESS: 'ServiceRequests/MarkDiscussionUnread/Success',
  FAILURE: 'ServiceRequests/MarkDiscussionUnread/Failure'
};

export const CREATE = {
  REQUEST: 'ServiceRequests/SendDiscussionMessage/Request',
  SUCCESS: 'ServiceRequests/SendDiscussionMessage/Success',
  FAILURE: 'ServiceRequests/SendDiscussionMessage/Failure'
};

export const MARK_AS_SEEN = {
  REQUEST: 'ServiceRequests/MarkDiscussionAsSeen/Request',
  SUCCESS: 'ServiceRequests/MarkDiscussionAsSeen/Success',
  FAILURE: 'ServiceRequests/MarkDiscussionAsSeen/Failure'
};
